import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelDashboardOption,
  leaveWorkspace,
} from "../../state/workspaces/workspaces.actions";
import { selectSelectedWorkspace } from "../../state/workspaces/workspaces.selector";
import { useI18n } from "../../utils/hooks/use.i18n";
import { ConfirmationDialog } from "./ConfirmationDialog";

export const LeaveWorkspaceDialog = () => {
  const dispatch = useDispatch();

  const selectedWorkspace = useSelector(selectSelectedWorkspace);

  const t = useI18n("LEAVE_WORKSPACE_DIALOG.");

  return (
    <ConfirmationDialog
      buttonText={t("LEAVE")}
      cancelAction={() => dispatch(cancelDashboardOption())}
      icon="hoylu-ui-icons-x"
      message={t("WARNING")}
      submitAction={() =>
        selectedWorkspace && dispatch(leaveWorkspace.request(selectedWorkspace))
      }
      title={`${t("LEAVE")} "${selectedWorkspace?.workspaceName}"`}
    />
  );
};

export default LeaveWorkspaceDialog;
